import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IsNullOrEmpty } from "../../../helpers/utility";
import {
    getPrivateLoungeRequest,
    updatePrivateLoungeRequest,
} from "../../../store/user/privatelounge/privatelounge.actions";
import { getCurrentPrivateLounge } from "../../../store/user/privatelounge/privatelounge.selector";

const SetPrivateSubscription = (props) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState(false);
    const [annuallySubscription, setAnnuallySubscription] = useState("");
    const [monthlySubscription, setMonthlySubscription] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState("set");

    const { privacylounge } = useSelector((state) => {
        return {
            privacylounge: getCurrentPrivateLounge(state),
        };
    });

    useEffect(() => {
        dispatch(getPrivateLoungeRequest());
    }, []);

    useEffect(() => {
        if (privacylounge) {
            setAnnuallySubscription(privacylounge.annuallySubscription);
            setMonthlySubscription(privacylounge.monthlySubscription);
            setDescription(privacylounge.description);
        }
    }, [privacylounge]);

    const validate = () => {
        return (
            !IsNullOrEmpty(monthlySubscription) &&
            !IsNullOrEmpty(annuallySubscription) &&
            !IsNullOrEmpty(description)
        );
    };

    const handleSave = () => {
        if (validate()) {
            dispatch(
                updatePrivateLoungeRequest({
                    monthlySubscription: monthlySubscription,
                    description: description,
                    annuallySubscription: annuallySubscription,
                })
            );
        } else {
            setForm(true);
        }
    };

    return (
        <div>
            <div className="mb-4">
                <h3 className="text-lg font-medium text-ebony-color">
                    Private lounge
                </h3>
                <p className="text-sm font-medium text-black-60">
                    User can set a monthly subscription fee for their private
                    lounge.
                </p>
            </div>

            <div className="md:max-w-[381px]">
                <div className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] relative">
                    <label
                        htmlFor="monthly-subscription"
                        className="placeholder:text-black-50 text-ebony-color capitalize mb-px"
                    >
                        Monthly Subscription Fee
                    </label>
                    <input
                        type="text"
                        className="text-black-60 outline-none"
                        id="monthly-subscription"
                        value={monthlySubscription}
                        onChange={(e) => {
                            setMonthlySubscription(e.target.value);
                            setAnnuallySubscription(12 * e.target.value);
                        }}
                    />
                    <span className="absolute bottom-[9px] right-[13px] text-black-50">
                        / month
                    </span>
                </div>
                <div className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] relative">
                    <label
                        htmlFor="yearly-ubscription"
                        className="placeholder:text-black-50 text-ebony-color capitalize mb-px"
                    >
                        Yearly Subscription Fee
                    </label>
                    <input
                        type="text"
                        className="text-black-60 outline-none"
                        id="yearly-ubscription"
                        value={annuallySubscription}
                        onChange={(e) =>
                            setAnnuallySubscription(e.target.value)
                        }
                    />
                    <span className="absolute bottom-[9px] right-[13px] text-black-50">
                        / year
                    </span>
                </div>
                <div className="">
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        name=""
                        id=""
                        cols="20"
                        rows="6"
                        className="w-full min-h-[100px] outline-none placeholder:text-black-50 text-ebony-color p-2 text-sm rounded-md border border-black-10 shadow-[0_1px_2px] shadow-black-5"
                        placeholder="Description"
                    ></textarea>
                </div>
                <button
                    onClick={() => handleSave()}
                    type="submit"
                    className=" bg-orange-color text-white mt-5 py-2.5 w-full text-center font-bold rounded-lg text-sm capitalize"
                >
                    save
                </button>
            </div>
        </div>
    );
};

export default SetPrivateSubscription;
